var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIbmEventProcessing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ibm--event-processing_svg__clip0_61530_7305)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23.25a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM16.875 22.5H15V21h1.875A4.13 4.13 0 0021 16.875a4.108 4.108 0 00-3.172-4.015l.345-1.46a5.602 5.602 0 014.327 5.475 5.631 5.631 0 01-5.625 5.625zM15.31 10.94l-2.25-2.25A1.49 1.49 0 0012 8.25c-.4 0-.777.156-1.06.44l-2.25 2.25a1.496 1.496 0 000 2.12l2.25 2.25c.283.284.66.44 1.06.44s.777-.156 1.06-.44l2.25-2.25a1.496 1.496 0 000-2.12zM12 14.25L9.75 12 12 9.75 14.25 12 12 14.25zM12 3.75a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM5.827 12.6A5.603 5.603 0 011.5 7.125 5.631 5.631 0 017.125 1.5H9V3H7.125A4.13 4.13 0 003 7.125a4.108 4.108 0 003.173 4.015l-.346 1.46z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ibm--event-processing_svg__clip0_61530_7305"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgIbmEventProcessing;